/**
 * The measurements the section area and its skeleton are drawn to.
 *
 * They live here for one reason: the loading skeleton has to stand in for the
 * shape that is about to render, and a skeleton that restates the measurements
 * in its own words drifts the first time they change. Sharing the strings means
 * the placeholder is wrong only if the real thing is.
 */

/** How sections stack. `min-w-0` so a wide table inside a section scrolls
 * itself rather than stretching the column. */
export const SECTION_STACK = 'flex min-w-0 flex-col gap-11';

/** Where the section area starts, below the page's stat strip. */
export const SECTION_AREA_TOP = 'mt-8';
